/**
 * Normalize a value that may arrive either as a plain string (catalog metadata
 * column) or as a Choice dict `{token, title}` (full-object schema
 * serialization). Returns the token string, or null.
 *
 * The middleware has the same helper as `app.utils.vocabulary_token`.
 */
export const tokenOf = (value) => {
  if (value && typeof value === 'object') {
    return value.token ?? null;
  }
  return value ?? null;
};

export default tokenOf;
